import useUserContext from "../../shared/useUserContext";
import { IDANDEContext, IDANDEUserContext } from "../types";

export default function useDANDEContext(): IDANDEContext {
  const { dandeContext } = useUserContext() as IDANDEUserContext;
  return dandeContext;
}
